import { DateTime } from 'luxon';

import { Check } from 'lib/utils/formValidation/formValidation';
import isEmpty from 'lib/utils/formValidation/isEmpty';

const isRequiredDate: Check = (value) => {
  if (!value || isEmpty(value)) {
    return false;
  }

  return DateTime.fromISO(value as string).isValid;
};

export default isRequiredDate;

export const EMPTY_DATE = 'EMPTY_DATE';
